<script setup lang="ts">
import { ROUTE_NAV } from '@/shared/config'

const emit = defineEmits(['privacy', 'cookies', 'terms', 'purchase'])

const localePath = useLocalePath()
</script>

<template>
  <div class="mx-auto flex flex-col justify-center lg:flex-row lg:gap-56">
    <NuxtLink
      tag="a"
      :to="localePath(ROUTE_NAV.policy)"
      class="text-h7-medium text-center text-black lg:min-h-auto min-h-48"
      @click="emit('privacy')"
    >
      {{ $t('shared.privacy_policy') }}
    </NuxtLink>
    <NuxtLink
      tag="a"
      :to="localePath(ROUTE_NAV.cookiePolicy)"
      class="text-h7-medium text-center text-black lg:min-h-auto min-h-48"
      @click="emit('cookies')"
    >
      {{ $t('footer.cookie_policy') }}
    </NuxtLink>
    <NuxtLink
      tag="a"
      :to="localePath(ROUTE_NAV.terms)"
      class="text-h7-medium text-center text-black lg:min-h-auto min-h-48"
      @click="emit('terms')"
    >
      {{ $t('footer.terms_and_conditions_of_use') }}
    </NuxtLink>
    <NuxtLink
      tag="a"
      :to="localePath(ROUTE_NAV.purchaseTerms)"
      class="text-h7-medium text-center text-black lg:min-h-auto min-h-48"
      @click="emit('purchase')"
    >
      {{ $t('footer.purchase_and_subscription_terms') }}
    </NuxtLink>
    <NuxtLink
      tag="a"
      :to="localePath(ROUTE_NAV.doNotSellMyPersonalInfo)"
      class="text-h7-medium text-center text-black lg:min-h-auto min-h-48"
    >
      {{ $t('footer.do_not_send_my_personal_info') }}
    </NuxtLink>
  </div>
</template>
